import { render, staticRenderFns } from "./BFormInputSeletor.vue?vue&type=template&id=281ec872&scoped=true"
import script from "./BFormInputSeletor.vue?vue&type=script&lang=js"
export * from "./BFormInputSeletor.vue?vue&type=script&lang=js"
import style0 from "./BFormInputSeletor.vue?vue&type=style&index=0&id=281ec872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281ec872",
  null
  
)

export default component.exports